<app-mychart-web-header 
    [firstName]="patientFirstName">
</app-mychart-web-header>
<div *ngIf="isMobileResolution==false" class="get-care-now-background-web">
    <div class="get-care-now-container-web">
        <div class="get-care-now-title">{{title}}</div>
        <div class="custom-container-web">
            <app-ask-a-doctor
                class="get-care-now-row"
                [locale]="locale"
                [quickCareOptions]="quickCareOptions">
            </app-ask-a-doctor>
            <div *ngIf="showDivider"style="width: 0px; border-left: 1px solid #C5C5C5;"></div>
            <app-virtual-urgent-care
                class="get-care-now-row"
                [locale]="locale"
                [virtualUrgentCareOptions]="virtualUrgentCareOptions">
            </app-virtual-urgent-care>
            <div *ngIf="showDivider"style="width: 0px; border-left: 1px solid #C5C5C5;"></div>
             <app-in-person-urgent-care 
                class="get-care-now-row"
                [locale]="locale"
                [inpersonUrgentCareOptions]="inpersonUrgentCareOptions">
            </app-in-person-urgent-care>
            <div *ngIf="showDivider && primaryCareProviderOptions && primaryCareProviderOptions != null && primaryCareProviderOptions.length > 0"style="width: 0px; border-left: 1px solid #C5C5C5;"></div>
            <app-primary-care-provider
                *ngIf="primaryCareProviderOptions && primaryCareProviderOptions != null && primaryCareProviderOptions.length > 0"
                class="get-care-now-row"
                [locale]="locale"
                [primaryCareProviderOptions]="primaryCareProviderOptions"
                [pcpId]="pcpId">
            </app-primary-care-provider>
            <div *ngIf="showDivider"style="width: 0px; border-left: 1px solid #C5C5C5;"></div>
        </div>
        <div class="get-care-now-title"></div>
    </div>
</div>
<div  *ngIf="isMobileResolution" class="get-care-now-background-mobile">
    <div class="get-care-now-container-mobile">
        <div class="custom-container">
            <app-ask-a-doctor-mobile 
                [locale]="locale"
                [isPlus]="null"
                [quickCareOptions]="quickCareOptions">
            </app-ask-a-doctor-mobile>
        </div>
        <div class="custom-container">
            <app-virtual-urgent-care-mobile 
                [locale]="locale"
                [isPlus]="null"
                [virtualUrgentCareOptions]="virtualUrgentCareOptions">
            </app-virtual-urgent-care-mobile>
        </div>
        <div class="custom-container">
            <app-in-person-urgent-care-mobile 
                [locale]="locale"
                [isPlus]="null"
                [inpersonUrgentCareOptions]="inpersonUrgentCareOptions">
            </app-in-person-urgent-care-mobile>
        </div>
        <div class="custom-container" *ngIf="primaryCareProviderOptions && primaryCareProviderOptions != null && primaryCareProviderOptions.length > 0">
            <app-primary-care-provider-mobile 
                [locale]="locale"
                [isPlus]="null"
                [pcpId]="pcpId"
                [primaryCareProviderOptions]="primaryCareProviderOptions">
            </app-primary-care-provider-mobile>
        </div>
        <div>
        <app-need-help-deciding class="need-help-container" 
                [locale]="locale">
            </app-need-help-deciding>
        </div>
    </div>
</div>


